const MiniIsotype = props => {
  const { width = '' } = props
  return (<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 4 25 25" width={width}>
    <circle cx="12.5" cy="16.5" r="12" fill="#EEF2FF" />
    <path fill="#6C85D3" fillRule="evenodd" d="M12.5 9.8a4.7 4.7 0 0 0-4.7 4.7c0 3.5 4.7 8.7 4.7 8.7s4.7-5.2 4.7-8.7c0-2.6-2.1-4.7-4.7-4.7Zm0 6.4a1.7 1.7 0 1 1 0-3.4 1.7 1.7 0 0 1 0 3.4Z" clipRule="evenodd" />
  </svg>)
}

export default MiniIsotype